import { useTranslation } from "react-i18next";
import { PMSimpleSelectorFieldV2 } from "../PMSimpleSelector/PMSimpleSelectorFieldV2";
import axios from "../../../api/axios";
import { useState, useEffect, useMemo } from "react";
import { debounce } from "lodash";

function formatCalcListSecondary(row, t, formatMoney) {
  const addr = row?.delivery_address?.displayTitle;
  const entries = row?.additional_work_calculator_data?.entries;
  const first = Array.isArray(entries) && entries.length > 0 ? entries[0] : null;
  const totals = first?.totals;
  const ex = totals?.customer_total_ex_vat;
  const inc = totals?.customer_total_inc_vat;
  if (ex == null && inc == null) {
    return addr || "";
  }
  const calcPart = t("report.additional_work_calculator.selectorCalcSummary", {
    ex: formatMoney(ex),
    inc: formatMoney(inc),
  });
  if (addr) return `${calcPart} · ${addr}`;
  return calcPart;
}

export const ReportSelector = ({ showField = true, ...props }) => {
  const { setFieldValue, values, onChange, errors, searchQuery } =
    props;

  const name = props?.name ? props.name : "report_id";
  const label = props?.label ? props.label : "Report";
  const FETCH_URL = `/service/reports/`;
  const CREATE_URL = `/service/reports/`;
  const onlyWithPriceCalculator = Boolean(props.onlyWithPriceCalculator);
  const listSecondaryLimit = props.listSecondaryLimit ?? 35;
  const filters = useMemo(
    () =>
      onlyWithPriceCalculator
        ? [{ name: "has_additional_work_calculator", value: "true" }]
        : null,
    [onlyWithPriceCalculator]
  );

  const { t } = useTranslation();

  const formatMoney = (n) =>
    `kr ${Math.round(Number(n) || 0).toLocaleString("nb-NO")}`;

  const [query, setQuery] = useState();
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState({
    id: 0,
    field1: "Ingen valgt",
    field2: null,
  });
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const labelAction = {
    // path: selected?.id ? "/dashboard/customers/" + selected?.id : null,
    action: () => {},
  };

  useEffect(() => {
    if (props.open === true) setOpen(true);
    else if (props.open === false) setOpen(false);
  }, [props.open]);

  const handleChange = (data) => {
    const item = data?.selected?.item;
    if (item == null || item.id == null) {
      return;
    }

    setSelected({
      id: item.id,
      field1: item.primary,
    });

    setOpen(false);
    props.onModalClose?.();

    if (values) {
      setFieldValue(name, item.id);
    }
    if (onChange) {
      onChange({
        target: {
          name: name,
          value: item.id,
          data: item,
          report: item.object,
        },
      });
    }
  };

  useEffect(() => {
    if (props?.selected?.id) {
      setSelected({
        id: props.selected?.id,
        field1: props.selected?.displayTitle,
      });
    }
  }, [props.selected]);

  const handleSelectFromForm = (data) => {
    setSelected({
      id: data?.id,
      field1: data?.displayTitle,
    });
    if (values) {
      setFieldValue(name, data?.id);
    } else {
      onChange({ target: { name: name, value: data?.id } });
    }
  };

  const defaultFields = onlyWithPriceCalculator
    ? "id,displayTitle,customer,delivery_address,report_number,additional_work_calculator_data"
    : "id,displayTitle,customer,delivery_address";

  const [controller, setController] = useState({
    query: query ? query : "",
    page: 1,
    sortBy: "updated_at",
    sort: onlyWithPriceCalculator ? "desc" : "asc",
    filters: filters,
    fields: props.fields || defaultFields,
    view: null,
  });

  useEffect(() => {
    setController((prev) => ({ ...prev, query: query }));
  }, [query]);

  const getItems = (controller) => {
    setLoading(true);
    return axios({ method: "get", url: FETCH_URL, params: controller })
      .then((response) => {
        if (response.data.data) {
          var array = onlyWithPriceCalculator
            ? []
            : [{ id: null, value: null, primary: "Ingen valgt", secondary: null }];
          if (!response.data.data) return array;
          response.data.data.map((row, i) => {
            const rowParams = {
              value: row.id,
              id: row.id,
              primary: row?.displayTitle + " - " + row?.customer?.displayTitle,
              secondary: onlyWithPriceCalculator
                ? formatCalcListSecondary(row, t, formatMoney)
                : row?.delivery_address?.displayTitle,
              object: row,
            };
            array.push(rowParams);
          });
          setItems(array);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        return error.response.data;
      });
  };

  const debouncedDispatchAction = debounce((controller) => {
    getItems(controller);
  }, 500);

  useEffect(() => {
    // Trigger the debounced dispatch action
    if (open) {
      debouncedDispatchAction(controller);
    }

    // Clean the debounced function on component unmount.
    return () => {
      debouncedDispatchAction.cancel();
    };
  }, [controller, open]);

  const handleToggleOpen = () => {
    setOpen((prev) => {
      if (prev) {
        props.onModalClose?.();
        return false;
      }
      return true;
    });
  };

  // useEffect(() => {
  //   if (values[name]) {
  //     getItem(values[name]);
  //   }
  // }, [items]);

  return (
    <>
      <PMSimpleSelectorFieldV2
        showField={showField}
        errors={errors}
        name={name}
        loading={loading}
        label={t(label)}
        labelAction={labelAction}
        options={items}
        selected={selected}
        onChange={handleChange}
        onQueryChange={(query) => setQuery(query)}
        onClose={handleToggleOpen}
        open={open}
        searchQuery={searchQuery}
        listSecondaryLimit={listSecondaryLimit}
      />
    </>
  );
};
